
import { Icon, Wrapper } from './styles';
import Heading from '../Heading/index.vue';

export default {
  name: 'ResultMessage',
  components: {
    Heading,
    Wrapper,
  },
  props: {
    image: {
      type: String,
      default: 'no-producers',
      validator(value: typeof Icon[number]) {
        return Icon.indexOf(value) !== -1;
      },
    },
    imageHeight: {
      type: Number,
      default: 216,
    },
    imageWidth: {
      type: Number,
      default: 216,
    },
    message: {
      type: String,
      default: '',
    },
  },
};
